import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd11a1bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "person")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_contact_message_modal = _resolveComponent("contact-message-modal")!
  const _component_message = _resolveComponent("message")!

  return (_openBlock(), _createBlock(_component_message, {
    message: _ctx.message,
    class: "contact-message"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["contact-card", [_ctx.message.sender]]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.detailsModal.open()))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("h2", null, _toDisplayString(_ctx.message.content.name.formatted_name || "Unbekannt"), 1)
        ]),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : _createCommentVNode("", true)
      ], 2),
      _createVNode(_component_contact_message_modal, {
        contact: _ctx.message.content,
        ref: "detailsModal"
      }, null, 8, ["contact"])
    ]),
    _: 1
  }, 8, ["message"]))
}